<template>
  <iframe
    :src="url"
    width="100%"
    height="100%"
    style="border:none"
  />
</template>

<script>

export default {
  name: 'PdfViewer',
  components: {
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const path = `/pdf-viewer?url=${this.url}`
    const randNumber = Math.ceil(Math.random() * 100)
    if (this.$router.path !== path) {
      this.$router.replace({ path: '/pdf-viewer', query: { url: this.url, randNumber } })
    }
  },            
}
</script>

<style scoped>

</style>
